import React, { useState } from 'react';
import { connect } from 'react-redux';
import { notification } from 'antd';
import RequestOriModal from './RequestOriModal';
import { requestNewOri } from '../store/reducers';
import { requestOriBlankMessage, requestOriInvalidMessage, requestOriSuccessMessage } from '../utils/confirmationMessage';
import { requestOriErrorMessage } from '../utils/errorMessage';
import { httpStatusCode } from '../utils/errorCodes';

const RequestOri = ({ isOriBlank, isOriInvalid, requestOri }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const openModal = () => setIsModalVisible(true);
    const closeModal = () => setIsModalVisible(false);

    const handleSubmitOri = async (newOri) => {
        try {
            const response = await requestOri(newOri);

            if (response === true) {
                notification.success({
                    message: 'Success',
                    description: requestOriSuccessMessage(),
                });
            } else if (response[1]?.Status === httpStatusCode.badRequest) {
                notification.error({
                    message: 'Error',
                    description: requestOriErrorMessage(),
                });
            }else{
                notification.error({
                    message: 'Error',
                    description: requestOriErrorMessage(),
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: requestOriErrorMessage(),
            });
        }
        closeModal();

    };

    return (
        <>
            <div className="request-ori-required">
                {isOriBlank ? (
                    <div>
                        {requestOriBlankMessage('paragraphOne')}
                        <span onClick={openModal} className="request-ori-link"> {requestOriBlankMessage('span')} </span>
                        {requestOriBlankMessage('paragraphTwo')}
                    </div>
                ) : isOriInvalid && (
                    <div>
                        <b>{requestOriInvalidMessage('boldText')}</b>
                        <br />
                        {requestOriInvalidMessage('paragraphOne')}
                        <span onClick={openModal} className="request-ori-link">{requestOriInvalidMessage('span')}</span>
                        {requestOriInvalidMessage('paragraphTwo')}
                    </div>
                )}
            </div>

            <RequestOriModal
                show={isModalVisible}
                onClose={closeModal}
                onSave={handleSubmitOri}
            />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    requestOri: (newOri) => dispatch(requestNewOri(newOri)),
});

export default connect(null, mapDispatchToProps)(RequestOri);
